"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var css_1 = require("@emotion/css");
var preact_1 = require("preact");
var avatar_1 = __importDefault(require("./avatar"));
var verified_badge_1 = __importDefault(require("./verified-badge"));
var containerCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    font-family: interface, helvetica, arial;\n"], ["\n    display: flex;\n    align-items: center;\n    font-family: interface, helvetica, arial;\n"])));
var avatarCss = (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-shrink: 0;\n"], ["\n    flex-shrink: 0;\n"])));
var userName = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: white;\n    font-size: 17px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-font-smoothing: antialiased;\n"], ["\n    color: white;\n    font-size: 17px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    -webkit-font-smoothing: antialiased;\n"])));
var verifiedBadge = (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0 4px;\n    flex-shrink: 0;\n"], ["\n    margin: 0 4px;\n    flex-shrink: 0;\n"])));
var Attribution = function (_a) {
    var gif = _a.gif, className = _a.className, onClick = _a.onClick;
    var user = gif.user;
    if (!(user === null || user === void 0 ? void 0 : user.username) && !(user === null || user === void 0 ? void 0 : user.display_name)) {
        return null;
    }
    var display_name = user.display_name, username = user.username;
    return ((0, preact_1.h)("div", { className: (0, css_1.cx)(containerCss, Attribution.className, className), onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (onClick) {
                onClick(gif);
            }
            else {
                var url = user.profile_url;
                if (url)
                    window.open(url, '_blank');
            }
        } },
        (0, preact_1.h)(avatar_1.default, { user: user, className: avatarCss }),
        (0, preact_1.h)("div", { className: userName }, display_name || "@".concat(username)),
        user.is_verified ? (0, preact_1.h)(verified_badge_1.default, { size: 14, className: verifiedBadge }) : null));
};
Attribution.className = 'giphy-attribution';
exports.default = Attribution;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map